<script setup lang="ts">
  import { provide } from 'vue'

  const props = defineProps<{
    slideIndex?: number
  }>()

  // Provide slide index to child components
  if (props.slideIndex !== undefined) {
    provide('slideIndex', props.slideIndex)
  }
</script>
<template>
  <div class="slide-container">
    <slot />
  </div>
</template>
<style scoped>
  .slide-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
</style>
